module.exports = __webpack_public_path__ + "media/shiguang.e9117168.mp3";